document.documentElement.classList.remove('no-js');



function initCollectionSwitchers(root = document) {
  root.querySelectorAll('[data-collection-switcher]').forEach((switcher) => {
    if (switcher.dataset.collectionSwitcherReady === 'true') return;
    switcher.dataset.collectionSwitcherReady = 'true';

    const buttons = Array.from(switcher.querySelectorAll('[data-collection-filter]'));
    const panels = Array.from(switcher.querySelectorAll('[data-collection-panel]'));
    const results = switcher.querySelector('[data-collection-results]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const key = button.dataset.collectionFilter;

        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.collectionPanel !== key;
        });

        if (results) {
          window.setTimeout(() => {
            results.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 30);
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initCollectionSwitchers();
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const price = select.closest('[data-product-form]')?.parentElement?.querySelector('[data-product-price]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    });
  });
});

document.addEventListener('click', (event) => {
  const minus = event.target.closest('[data-qty-minus]');
  const plus = event.target.closest('[data-qty-plus]');
  if (!minus && !plus) return;
  const wrapper = event.target.closest('.mh-cart-quantity');
  const input = wrapper?.querySelector('[data-qty-input]');
  if (!input) return;
  const current = Number.parseInt(input.value || '0', 10);
  input.value = String(Math.max(0, current + (plus ? 1 : -1)));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});


// Keep the checklist cart quantities working without adding a visible update button.
document.addEventListener('change', (event) => {
  const input = event.target.closest?.('[data-qty-input]');
  if (!input) return;
  const form = input.closest('form');
  const updateButton = form?.querySelector('[data-cart-update]');
  if (!updateButton) return;
  window.clearTimeout(form._mhCartUpdateTimer);
  form._mhCartUpdateTimer = window.setTimeout(() => updateButton.click(), 450);
});

document.addEventListener('shopify:section:load', (event) => initCollectionSwitchers(event.target));

/* Product-card quick add + quick select */
async function mhAddVariantToCart(variantId, trigger, messageNode) {
  if (!variantId || !window.MH_ROUTES) return;
  const original = trigger?.textContent;
  if (trigger) {
    trigger.disabled = true;
    trigger.classList.add('is-loading');
    trigger.textContent = '…';
  }
  if (messageNode) messageNode.textContent = '';

  try {
    const response = await fetch(window.MH_ROUTES.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: String(variantId), quantity: 1 }] })
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'This item could not be added.');

    const cartResponse = await fetch(window.MH_ROUTES.cart, { headers: { Accept: 'application/json' } });
    const cart = await cartResponse.json();
    document.querySelectorAll('.cart-count').forEach((count) => {
      count.textContent = cart.item_count;
    });

    if (trigger) {
      trigger.classList.remove('is-loading');
      trigger.classList.add('is-added');
      trigger.textContent = '✓';
      window.setTimeout(() => {
        trigger.textContent = original || '＋';
        trigger.classList.remove('is-added');
        trigger.disabled = false;
      }, 1400);
    }
    if (messageNode) messageNode.textContent = 'Added to your cart checklist!';
    return true;
  } catch (error) {
    if (messageNode) messageNode.textContent = error.message;
    if (trigger) {
      trigger.classList.remove('is-loading');
      trigger.textContent = original || '＋';
      trigger.disabled = false;
    }
    return false;
  }
}

document.addEventListener('click', async (event) => {
  const directButton = event.target.closest('[data-quick-add]');
  if (directButton) {
    event.preventDefault();
    await mhAddVariantToCart(directButton.dataset.variantId, directButton);
    return;
  }

  const openButton = event.target.closest('[data-quick-add-open]');
  if (openButton) {
    event.preventDefault();
    const modal = openButton.closest('[data-product-card]')?.querySelector('[data-quick-add-modal]');
    if (modal?.showModal) modal.showModal();
    else if (modal) modal.setAttribute('open', '');
    return;
  }

  const closeButton = event.target.closest('[data-quick-add-close]');
  if (closeButton) {
    const modal = closeButton.closest('[data-quick-add-modal]');
    if (modal?.close) modal.close();
    else modal?.removeAttribute('open');
  }
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-quick-add-form]');
  if (!form) return;
  event.preventDefault();
  const select = form.querySelector('[data-quick-add-variant]');
  const submit = form.querySelector('[type="submit"]');
  const message = form.querySelector('[data-quick-add-message]');
  const success = await mhAddVariantToCart(select?.value, submit, message);
  if (success) {
    window.setTimeout(() => {
      const modal = form.closest('[data-quick-add-modal]');
      if (modal?.close) modal.close();
    }, 900);
  }
});

document.addEventListener('click', (event) => {
  const modal = event.target.closest?.('[data-quick-add-modal]');
  if (modal && event.target === modal && modal.close) modal.close();
});

/* Require Discord name and terms before checkout. The values are cart attributes and carry to the Shopify order. */
function initCartRequirements(root = document) {
  const box = root.querySelector?.('[data-cart-requirements]');
  if (!box || box.dataset.cartRequirementsReady === 'true') return;
  box.dataset.cartRequirementsReady = 'true';

  const form = box.closest('form');
  const discordInput = box.querySelector('[data-discord-name]');
  const termsCheckbox = box.querySelector('[data-terms-checkbox]');
  const checkoutButton = form?.querySelector('[data-checkout-button]');
  const status = box.querySelector('[data-cart-requirements-status]');
  if (!form || !discordInput || !termsCheckbox || !checkoutButton) return;

  const updateState = () => {
    const hasDiscord = discordInput.value.trim().length > 0;
    const hasTerms = termsCheckbox.checked;
    const complete = hasDiscord && hasTerms;

    box.classList.toggle('is-complete', complete);
    checkoutButton.disabled = !complete;
    discordInput.setAttribute('aria-invalid', String(!hasDiscord));

    if (status) {
      if (complete) status.textContent = 'Check-in complete — you may proceed to checkout.';
      else if (!hasDiscord && !hasTerms) status.textContent = 'Enter your Discord name and check the agreement box to continue.';
      else if (!hasDiscord) status.textContent = 'Enter your Discord name to continue.';
      else status.textContent = 'Check the required agreement box to continue.';
    }
  };

  discordInput.addEventListener('input', updateState);
  termsCheckbox.addEventListener('change', updateState);

  const prepareCheckoutTarget = () => {
    // Shopify checkout cannot render inside the theme editor/preview iframe.
    // In an embedded preview, submit the native Shopify cart form into a new
    // browser tab. On the live storefront, checkout stays in the same tab.
    const isEmbeddedPreview = window.self !== window.top || window.Shopify?.designMode === true;
    form.removeAttribute('target');
    if (isEmbeddedPreview) checkoutButton.setAttribute('formtarget', '_blank');
    else checkoutButton.removeAttribute('formtarget');
    return isEmbeddedPreview;
  };

  checkoutButton.addEventListener('click', prepareCheckoutTarget);

  form.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (submitter?.name !== 'checkout') return;
    const isEmbeddedPreview = prepareCheckoutTarget();
    updateState();
    if (!discordInput.value.trim() || !termsCheckbox.checked) {
      event.preventDefault();
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => {
        if (!discordInput.value.trim()) discordInput.focus();
        else termsCheckbox.focus();
      }, 350);
      return;
    }
    if (isEmbeddedPreview && status) {
      status.textContent = 'Opening secure checkout in a new tab…';
    }
  });

  updateState();
}

document.addEventListener('DOMContentLoaded', () => initCartRequirements());
document.addEventListener('shopify:section:load', (event) => initCartRequirements(event.target));

/* Turn the notebook checkboxes beside cart products into working multi-select removal controls. */
function initCartBulkRemove(root = document) {
  const container = root.querySelector?.('[data-cart-bulk-actions]');
  if (!container || container.dataset.cartBulkReady === 'true') return;
  container.dataset.cartBulkReady = 'true';

  const form = container.closest('form');
  const itemCheckboxes = Array.from(form?.querySelectorAll('[data-cart-select]') || []);
  const selectAll = container.querySelector('[data-cart-select-all]');
  const removeButton = container.querySelector('[data-cart-remove-selected]');
  const selectedCount = container.querySelector('[data-cart-selected-count]');
  const status = container.querySelector('[data-cart-bulk-status]');
  const updateButton = form?.querySelector('[data-cart-update]');
  if (!form || !itemCheckboxes.length || !selectAll || !removeButton) return;

  const getSelected = () => itemCheckboxes.filter((checkbox) => checkbox.checked);

  const updateState = () => {
    const selected = getSelected();
    const count = selected.length;
    removeButton.disabled = count === 0;
    removeButton.textContent = count ? `REMOVE SELECTED (${count})` : 'REMOVE SELECTED';
    if (selectedCount) selectedCount.textContent = `${count} selected`;
    selectAll.checked = count === itemCheckboxes.length;
    selectAll.indeterminate = count > 0 && count < itemCheckboxes.length;

    itemCheckboxes.forEach((checkbox) => {
      checkbox.closest('[data-cart-line]')?.classList.toggle('is-selected', checkbox.checked);
    });
  };

  itemCheckboxes.forEach((checkbox) => checkbox.addEventListener('change', updateState));

  selectAll.addEventListener('change', () => {
    itemCheckboxes.forEach((checkbox) => {
      checkbox.checked = selectAll.checked;
    });
    updateState();
  });

  removeButton.addEventListener('click', async () => {
    const selected = getSelected();
    if (!selected.length) return;

    const updates = {};
    selected.forEach((checkbox) => {
      const key = checkbox.dataset.lineKey;
      if (key) updates[key] = 0;
      checkbox.closest('[data-cart-line]')?.classList.add('is-removing');
    });

    removeButton.disabled = true;
    removeButton.textContent = 'REMOVING…';
    if (status) status.textContent = `Removing ${selected.length} selected item${selected.length === 1 ? '' : 's'}…`;

    try {
      const route = window.MH_ROUTES?.cartUpdate || '/cart/update.js';
      const response = await fetch(route, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'The selected items could not be removed.');
      window.location.reload();
    } catch (error) {
      // Reliable non-AJAX fallback using the existing hidden Shopify cart update button.
      selected.forEach((checkbox) => {
        const quantity = checkbox.closest('[data-cart-line]')?.querySelector('[data-qty-input]');
        if (quantity) quantity.value = '0';
      });
      if (updateButton) {
        updateButton.click();
      } else {
        selected.forEach((checkbox) => checkbox.closest('[data-cart-line]')?.classList.remove('is-removing'));
        removeButton.disabled = false;
        if (status) status.textContent = error.message;
        updateState();
      }
    }
  });

  updateState();
}

document.addEventListener('DOMContentLoaded', () => initCartBulkRemove());
document.addEventListener('shopify:section:load', (event) => initCartBulkRemove(event.target));

/* Clickable product image gallery, including inside Shopify theme editor reloads. */
function initProductGalleries(root = document) {
  root.querySelectorAll?.('[data-product-gallery]').forEach((gallery) => {
    if (gallery.dataset.galleryReady === 'true') return;
    gallery.dataset.galleryReady = 'true';

    const mainImage = gallery.querySelector('[data-product-main-image]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-product-thumb]'));
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.imageSrc;
        const srcset = thumb.dataset.imageSrcset;
        const alt = thumb.dataset.imageAlt || '';
        if (!src) return;

        mainImage.src = src;
        if (srcset) mainImage.srcset = srcset;
        mainImage.alt = alt;

        thumbs.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-current', String(active));
        });
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initProductGalleries());
document.addEventListener('shopify:section:load', (event) => initProductGalleries(event.target));
